import { carnegieMap } from '@common-types';

export const getSchoolType = (type?: number) => {
  if (!type) return '';

  const carnegieLabel = carnegieMap.get(type);

  if (carnegieLabel === '2-year') {
    return '2 YRS';
  }

  if (carnegieLabel === '4-year') {
    return '4+YRS';
  }

  if (carnegieLabel === 'Graduate') {
    return 'GRAD';
  }

  if (carnegieLabel === 'Vocational/Technical') {
    return 'TRADE';
  }

  return '';
};

export const getEnrollmentSize = (size: number) => {
  if (size > 15000) return 'Large';
  if (size > 5000) return 'Medium';
  if (size <= 5000) return 'Small';

  return '';
};

export const getDistanceLabel = (distanceMiles?: number) =>
  distanceMiles && distanceMiles > 0 ? `${distanceMiles} mi` : undefined;

export const getSchoolCost = (cost?: number) => {
  if (!cost || cost < 500) return '';

  return `${Math.round(cost / 1000)}K AVG`;
};
